export const openAIConstants = {
    OPEN_AI_LIST_PENDING: 'OPEN_AI_LIST_PENDING',
    OPEN_AI_LIST_FULFILLED: 'OPEN_AI_LIST_FULFILLED',
    OPEN_AI_LIST_REJECTED: 'OPEN_AI_LIST_REJECTED',
    OPEN_AI_CLEAR: 'OPEN_AI_CLEAR',
};
